window._env = {
    hostname: 'http://devpedro.andy.media',
    universal: true,
    debug: true,
    disableRouter: true,
    ignoreHostnameValidation: true
}